import { useRecoilState, useRecoilValue } from 'recoil';
import { userState } from '../../../states/userState';
import {
  constructions,
  constructionsForInput,
} from '../../../utils/variables/constructions';
import SelectBox from '../../uikit/atoms/selectboxes/SelectBox';
import TextInputForproductBno from '../../uikit/atoms/textfields/TextInputForProductBno';
import TextInputForProductNo from '../../uikit/atoms/textfields/TextInputForProductNo';
import SelectBoxForFactory from '../../uikit/molecules/selectboxes/SelectBoxForFactory';
import classes from './HeaderController.module.scss';
import React, { FC, useEffect, useState } from 'react';
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager';
import { User } from '../../../types';
import SetWorkersButton from '../../uikit/atoms/buttons/SetWorkersButton';
import FromToDatePickers from '../../uikit/molecules/selectboxes/datePickers/FromToDatePickers';
import { FetchButton } from '../../uikit/atoms/buttons/FetchButton';
import { ExportButton } from '../../uikit/atoms/buttons/ExportButton';
import { useGetDiaryList } from '../../../hooks/api/posts/useGetDiraryList';
import { formatDate } from '../../../utils/functions/formatting';
import {
  diaryListState,
  diaryListStateForMatrix,
} from '../../../states/diaryListState';
import {
  Calendar,
  Dirary,
  WorkerForMatrix,
  processInfo,
  summaryByProductNo,
  summaryByWorker,
} from '../../../types/dirary';
import {
  calendarListState,
  calendarListStateForMatrix,
} from '../../../states/calendarListState';
import { useGetMorimatsuCalendar } from '../../../hooks/api/calendar/useGetMorimatsuCalendar';
import {
  processListState,
  processListStateForMatrix,
} from '../../../states/processListState';
import { useGetProcessees } from '../../../hooks/api/processes/useGetProcesses';
import SelectBoxForString from '../../uikit/atoms/selectboxes/SelectBoxForString';
import MonthPicker from '../../uikit/atoms/datepickers/MonthPicker';
import { factoriesForInput } from '../../../utils/variables/factoriesForInupt';
import SelectBoxForNumber from '../../uikit/atoms/selectboxes/SelectBoxForNumber';
import {
  extractUniqueWorkers,
  gatherDairyListAsProductNoAndDisplayName,
  gatherDairyListAsWorkerAndProductNoAndDisplayName,
} from '../../../utils/functions/summary';
import { currentDateState } from '../../../states/currentDateState';
import { fetchManageStateForMatrix } from '../../../states/fetchMnageState';
import useCsvDownloader from '../../../hooks/util/useCsvDownloarder';

const isButtonDisabled = (productNo: string, productBno: string) => {
  if (productNo.length < 8 || productBno.length < 2) {
    return true;
  }
  return false;
};

type Props = {
  workerList: WorkerForMatrix[];
  setWorkerList: React.Dispatch<React.SetStateAction<WorkerForMatrix[]>>;
  productNo: string;
  setProductNo: React.Dispatch<React.SetStateAction<string>>;
  productBno: string;
  setProductBno: React.Dispatch<React.SetStateAction<string>>;
};

const HeaderController: FC<Props> = (props) => {
  const { downloadCsv } = useCsvDownloader();
  const fetchDiaryMatrix = useRecoilValue(fetchManageStateForMatrix);
  const {
    workerList,
    setWorkerList,
    productNo,
    setProductNo,
    productBno,
    setProductBno,
  } = props;
  const [summaryAsWorker, setSummaryAsWorker] = useState<summaryByWorker[]>([]);
  const [summaryAsProductNo, setSummaryAsProductNo] = useState<
    summaryByProductNo[]
  >([]);
  //リコイル
  const [user, setUser] = useRecoilState<User>(userState);
  const [currentDate, setCurrentDate] = useRecoilState<Date>(currentDateState);
  const [recoilDiaryList, setRecoilDiaryList] = useRecoilState<Dirary[]>(
    diaryListStateForMatrix
  );
  const [calendarList, setCalendarList] = useRecoilState<Calendar[]>(
    calendarListStateForMatrix
  );
  const [processList, setProcessList] = useRecoilState<processInfo[]>(
    processListStateForMatrix
  );

  //APIフェッチ-カスタムフック
  const { getProcessesFromDiaryList } = useGetProcessees();
  const { getIsHolidayList } = useGetMorimatsuCalendar();
  const { getDiaryListByAllParams } = useGetDiaryList();

  //製番2フォーカス移動時に入力値を保持するためのstate
  const [toggleBnoClear, setToggleBnoClear] = useState(false);

  const getEndOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };
  const getStartOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() - 0, 1);
  };
  const today = currentDate;

  const [fromDate, setFromdate] = useState<Date>(getStartOfMonth(today)), //日付From
    [toDate, setTodate] = useState<Date>(getEndOfMonth(today)); //日付To

  // const handleSelectConstruction = (e: number) => {
  //   const value = e;
  //   setUser((prevUser: User) => {
  //     const newUser: User = {
  //       ...prevUser,
  //       initialParameters: {
  //         ...prevUser.initialParameters,
  //         constructionForMatrix: value,
  //       },
  //     };
  //     setUserToLocalStorage(newUser);
  //     return newUser;
  //   });
  //   // console.log(e);
  // };
  const handleFetchButtonClick = async () => {
    const formatFromDate = formatDate(fromDate);
    const formatToDate = formatDate(toDate);
    //日報情報の取得
    const workerArray: number[] = [];
    const diaryList = await getDiaryListByAllParams(
      user.initialParameters.productNoForMatrix ?? '',
      user.initialParameters.productBnoForMatrix ?? '',
      workerArray,
      formatFromDate,
      formatToDate,
      [user.initialParameters.factoryNoForMatrix]
      // user.initialParameters.constructionForMatrix
    );
    if (!diaryList || diaryList.length === 0) {
      setRecoilDiaryList([]);
      setCalendarList([]);
      setProcessList([]);
      setWorkerList([]);
      return;
    }
    setRecoilDiaryList(diaryList);
    setWorkerList(extractUniqueWorkers(diaryList));
    //稼働日カレンダーの取得（日付と稼働日のリスト）
    const calendarList = await getIsHolidayList(formatFromDate, formatToDate);
    setCalendarList(calendarList);
    // // 工程の取得
    const processList = await getProcessesFromDiaryList(diaryList);
    setProcessList(processList);
  };
  const handleExportButtonClick = () => {
    downloadCsv(recoilDiaryList, 'diary_list');
  };
  useEffect(() => {
    if (
      // recoilDiaryList.length === 0 &&
      productNo.length >= 8 &&
      productBno.length >= 2
    ) {
      const fetchDiaryList = async () => {
        await handleFetchButtonClick();
      };
      fetchDiaryList();
    }
  }, [fetchDiaryMatrix]);

  //工場変更
  const handleFactoryChange = (e: number) => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          factoryNoForMatrix: e,
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  //
  useEffect(() => {
    const resultAsWorker =
      gatherDairyListAsWorkerAndProductNoAndDisplayName(recoilDiaryList);
    setSummaryAsWorker(resultAsWorker);
    const resultAsProductNo =
      gatherDairyListAsProductNoAndDisplayName(resultAsWorker);
    setSummaryAsProductNo(resultAsProductNo);
  }, [recoilDiaryList]);
  //社員番号の初期値を設定
  const [workerId, setWorkerId] = useState<string>(
    user.initialParameters.wokerIdForMatrix ?? ''
  );
  useEffect(() => {
    if (workerList.length > 0) {
      if (workerId === '') {
        setUser((prevUser: User) => {
          const newUser: User = {
            ...prevUser,
            initialParameters: {
              ...prevUser.initialParameters,
              wokerIdForMatrix: workerList[0].id,
            },
          };
          setUserToLocalStorage(newUser);
          return newUser;
        });
        setWorkerId(workerList[0].id);
      } else {
        const worker = workerList.find((worker) => worker.id === workerId);
        if (worker === undefined) {
          setUser((prevUser: User) => {
            const newUser: User = {
              ...prevUser,
              initialParameters: {
                ...prevUser.initialParameters,
                wokerIdForMatrix: workerList[0].id,
              },
            };
            setUserToLocalStorage(newUser);
            return newUser;
          });
          setWorkerId(workerList[0].id);
        }
      }
    }
  }, [workerList]);
  const handleWorkerChange = (e: string) => {
    setWorkerId(e);
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          wokerIdForMatrix: e,
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  useEffect(() => {
    setCurrentDate(fromDate);
  }, [fromDate, toDate]);

  const selectedWorkerSummary = summaryAsWorker.find(
    (worker) => worker.workerId === workerId
  );

  return (
    <div className={classes.rootContainer}>
      <div className={classes.searchParams}>
        <div className={classes.factory}>
          <p>製作工場</p>
          <SelectBoxForNumber
            label={''}
            options={factoriesForInput}
            required={true}
            select={handleFactoryChange}
            value={user.initialParameters.factoryNoForMatrix}
            disabled={false}
            width={'85px'}
            height={'38px'}
            fontSize={'12px'}
            colorMode={'light'}
            setMode={'input'}
          />
        </div>
        <div className={classes.productNoContainer}>
          <p>製作番号</p>
          <div>
            <div className={classes.ProductNo}>
              <TextInputForProductNo
                fullWidth={false}
                label={''}
                multiline={false}
                required={false}
                type={'number'}
                rows={1}
                disabled={false}
                // InputProps={true}
                placeholder={'01234567'}
                productNo={productNo}
                setProductNo={setProductNo}
                productBno={productBno}
                setProductBno={setProductBno}
                colorMode={'light'}
                setMode={'matrix'}
                setToggleBnoClear={setToggleBnoClear}
              />
            </div>
            <span className={classes.hyphen}>-</span>
            <div className={classes.ProductBNo}>
              {' '}
              <TextInputForproductBno
                fullWidth={false}
                label={''}
                multiline={false}
                required={false}
                type={'number'}
                rows={1}
                disabled={false}
                // InputProps={true}
                placeholder={'01'}
                productNo={productNo}
                setProductNo={setProductNo}
                productBno={productBno}
                setProductBno={setProductBno}
                colorMode={'light'}
                setMode={'matrix'}
                toggleBnoClear={toggleBnoClear}
              />
            </div>
          </div>
        </div>
        {/* <div className={classes.construction}>
          <p>工事区分</p>
          <div>
            <SelectBox
              label={"工事区分"}
              options={constructionsForInput}
              required={true}
              select={handleSelectConstruction}
              value={user.initialParameters.constructionForMatrix}
              disabled={false}
            />
          </div>
        </div> */}

        <div className={classes.datePickers}>
          <MonthPicker
            setFromdate={setFromdate}
            setTodate={setTodate}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>
        <div className={classes.buttons}>
          <div className={classes.fetch}>
            <FetchButton
              disabled={isButtonDisabled(productNo, productBno)}
              onClick={handleFetchButtonClick}
              caption={'検索実行'}
            />
          </div>
          <div className={classes.export}>
            <ExportButton
              disabled={false}
              onClick={handleExportButtonClick}
              caption={'CSV出力'}
            />
          </div>
        </div>
        {summaryAsProductNo.length > 0 && setSummaryAsWorker.length > 0 && (
          <div className={classes.resultContainer}>
            <div className={classes.result}>
              <div>
                <p>作業者</p>
                <div className={classes.select}>
                  <SelectBoxForString
                    label={''}
                    options={workerList}
                    required={true}
                    select={handleWorkerChange}
                    value={workerId}
                    disabled={false}
                    width={'120px'}
                    height={'32px'}
                    fontSize={'12px'}
                    setMode={'input'}
                    colorMode={'dark'}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedWorkerSummary && (
          <div className={classes.resultContainer}>
            <div className={classes.result}>
              <div className={classes.workingTime}>
                <p>作業時間</p>
                <p>
                  {`${
                    selectedWorkerSummary.totalWorkingTimeText
                  } （${selectedWorkerSummary.totalWorkingTimeByHour.toFixed(
                    1
                  )}）`}
                </p>
              </div>
              <div className={classes.siteName}>
                <p>表示名</p>
                <p className={classes.display}>
                  {selectedWorkerSummary.siteName}
                </p>
                <p className={classes.display}>
                  {selectedWorkerSummary.displayName}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderController;
